import { render, staticRenderFns } from "./StatsRadial.vue?vue&type=template&id=39148f9e&scoped=true"
import script from "./StatsRadial.vue?vue&type=script&setup=true&lang=js"
export * from "./StatsRadial.vue?vue&type=script&setup=true&lang=js"
import style0 from "./StatsRadial.vue?vue&type=style&index=0&id=39148f9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39148f9e",
  null
  
)

export default component.exports